module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "l-header"
  }, [_c('a', {
    staticClass: "ff-logo",
    attrs: {
      "href": "http://www.filzfelt.com"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "filzfelt",
      "src": require("../../assets/logo-ff.png"),
      "width": "179",
      "height": "44"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--portfolio is-first",
    attrs: {
      "href": "https://www.filzfelt.com/portfolio/categories/"
    }
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--products",
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--design-tool",
    attrs: {
      "href": "http://dt.filzfelt.com/"
    }
  }, [_vm._v("Design Tool")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--about",
    attrs: {
      "href": "https://www.filzfelt.com/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--shop",
    attrs: {
      "href": "https://www.filzfelt.com/shop/categories/"
    }
  }, [_vm._v("Shop")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57b811ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/wrappers/HeaderFilzfelt.vue
// module id = 569
// module chunks = 1